import * as API from "@/services/API";
import { RecordIdentifier } from "@/data/global";

export default {
    checkVoucher(voucher: string, regionId: RecordIdentifier|null = null) {
        return API.apiClient.post(`/voucher/check`, { voucher, regionId });
    },
    redeemVoucher(voucher: string) {
        return API.apiClient.post(`/voucher/redeem`, { voucher });
    },
}
